import {Payment} from './Payment';

import cls from '../../pages/Order/Order.module.scss';

export const PaymentPage = () => (
    <div className={cls.page}>
        <Payment/>
    </div>

)